import { services } from '../services';
var action = "contract";

export const contractService = {
    getContract,
    getContractByProperty,
    getContractOver
};

function getContract(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function getContractByProperty(id) {
    return services.restApi(`${action}/property/${id}`, 'GET');
}

function getContractOver(id) {
    return services.restApi(`${action}/over/${id}`, 'GET');
}




